import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import { Helpers } from "../../../../helpers/Helpers";
import { ResponseModel } from "../CalculateList";
import { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";

interface Props {
    responseList: ResponseModel[]
    isIn: boolean
    isOut: boolean
    selectedCurrencyType: CustomSingleSelectModel | undefined
}

const ResultInformation = ({ responseList, isIn, isOut, selectedCurrencyType }: Props) => {
    return (
        <div className='containerPart' /*ref={vehicleInformationRef}*/>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="text-black mb-10">Sonuç</h4>

                    <div className="row mt-5">
                        <div className="table-responsive">
                            <div className="col-md-12">
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th>Defter No</th>
                                            <th>Beyanname No</th>
                                            <th>Ürün Cinsi</th>
                                            <th>Hizmet Kalemi</th>
                                            <th>Birim Fiyat</th>
                                            <th>Miktar</th>
                                            <th>Hesaplama Formül</th>
                                            <th>Anlaşma Adı</th>
                                            <th>Toplam Tutar Döviz</th>
                                            <th>Döviz Cinsi</th>
                                            <th>Toplam Tutar TL</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            responseList.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            responseList.map((item, index) =>
                                                <tr>
                                                    <td>{item.ledgerNo}</td>
                                                    <td>{item.antrepoDeclarationNo}</td>
                                                    <td>{item.productKindName}</td>
                                                    <td>{item.serviceName}</td>
                                                    <td className="custom-text-right">{Helpers.correctPrice(item.unitPrice)}</td>
                                                    <td className="custom-text-right">{Helpers.correctPrice(item.quantity)}</td>
                                                    <td>{item.formula}</td>
                                                    <td>{item.agreementName}</td>
                                                    <td className="custom-text-right">{Helpers.correctPrice(item.total)}</td>
                                                    <td>{item.currencyTypeName}</td>
                                                    <td className="custom-text-right">{Helpers.correctPrice(item.localTotal)}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                    {
                                        responseList.length > 0 && (
                                            <tfoot className='text-gray-600 fw-bold'>
                                                <tr style={{ fontWeight: 'bold', color: 'red', borderTop: '1px solid rgba(0, 0, 0, 0.40)' }}>
                                                    <td className="custom-text-right" colSpan={8}>Toplam</td>
                                                    <td className="custom-text-right">{Helpers.correctPrice(Helpers.sumOfNumbers(responseList.filter(x => x.total).map(x => Helpers.toNumber(x.total))))}</td>
                                                    <td></td>
                                                    <td className="custom-text-right">{Helpers.correctPrice(Helpers.sumOfNumbers(responseList.filter(x => x.localTotal).map(x => Helpers.toNumber(x.localTotal))))}</td>
                                                </tr>
                                            </tfoot>
                                        )
                                    }
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default ResultInformation;